import { authRoles } from 'app/auth';
import RacsTesztlapTable from 'app/admin/racstesztlap/table/RacsTesztlapTable';
import RacsTesztlapEditForm from 'app/admin/racstesztlap/editform/RacsTesztlapEditForm';

export default [
	{
		path: '/racstesztlap/edit/:id',
		component: RacsTesztlapEditForm,
		auth: authRoles.szervezo
	},
	{
		path: '/racstesztlap/:sessionNameParam?',
		component: RacsTesztlapTable,
		auth: authRoles.szervezo
	}
];
